import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const getARSummary = async () =>
  httpRequest.get("/inv/dashboard/ar-summary");
